import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/reward-point";

export const pagingRewardPoint = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getRewardPointById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdateRewardPoint = (obj) =>
  axios.post(API_PATH + "/save-or-update", obj);

export const deleteRewardPoint = (id) =>
  axios.delete(API_PATH + "/voided-transaction/" + id);

export const resetPatientPoint = (patientId) =>
  axios.get(API_PATH + "/reset-patient-point/" + patientId);
